import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
import { useLocation, useParams } from 'react-router-dom'

import { useWidgetConfig } from '../../api/widget'
import { Font } from '../font'

// Theme wrapper that applies custom theme from widget config.
// Never blocks rendering - uses default theme while loading or on error.
// This prevents mount/unmount loops that cause request hammering.
export const WidgetTheme = ({ children }) => {
  const { projectId } = useParams()
  const location = useLocation()
  const token = new URLSearchParams(location.search).get('token')

  const { data: widgetConfig } = useWidgetConfig(projectId, token)

  const muiThemeConfig = widgetConfig?.muiThemeConfig
  const themeFonts = widgetConfig?.themeFonts

  let theme
  try {
    theme = createTheme(muiThemeConfig)
  } catch (error) {
    console.warn('Invalid theme configuration, using default theme:', error)
    theme = createTheme({})
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Font themeFonts={themeFonts} />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
